import "./productList.css";
import Product from "../product/Product";
import { green } from "../../data";
import { ice } from "../../data";
// import { black } from "../../data";
const ProductList = () => {
  return (
    <div className="pl">
      {/* <div className="pl-texts">
        <h1 className="pl-title">WHAT WE SERVE</h1>
        <p className="pl-desc">
        Sweven Tea is naturally caffeine free. It has a sweet refreshing smothning taste, (antioxidants, vanillic acid, gentistic acid, rosmarinic acid and syringic acid) which are known to have
protective or disease preventing properties.
Sweven offers a range of different flavours to ensure that you are offered variety and enjoyment while drinking tea. 
        </p>
      </div> */}
      <div className="pl-texts3" >  
      {/* <h1 className="pl-title4" > <b>JUST CLICK ON THE PRODUCT</b></h1> */}
      

     <h1 className="pl-title3">Servicing Vehicles</h1>
      {/* href="https://www.amazon.in/s?me=A1QWS82MLTEUXH&marketplaceID=A21TJRUUN4KGV" */}
      <div className="pl-list3">
        {ice.map((item) => (
          <Product key={item.id} img={item.img} href={item.link} tests={item.tests} />
        ))}
      
      </div></div>
      <div className="pl-texts1">
      <h1 className="pl-title1">Destination places</h1>
      <div className="pl-list">
        {green.map((item) => (
          <Product key={item.id} img={item.img} href={item.link} tests={item.tests}  />
        ))}
         {/* <div className="hello"><a href="https://www.amazon.in/Sweven-Jasmine-Natural-Flavour-Refreshing/dp/B0
         BR5QT56G/ref=sr_1_5?crid=2QGRZHJU9ZUWZ&keywords=sweven+jasmine+green+tea&qid=1674219219&sprefix=sweven+jas
         mine+green+te%2Caps%2C353&sr=8-5">
          <img src="https://i.ibb.co/wN1qqqq/Screenshot-20230117-165309-Amazon.jpg"alt=""
       ></img></a></div> */}
      </div>
      </div> 
      {/* <div className="jasmine"><img src="https://i.ibb.co/wN1qqqq/Screenshot-20230117-165309-Amazon.jpg" alt=""></img></div>
     */}
      {/* <div className="pl-texts2">   
      <h1 className="pl-title5" > <b>BUY 4<br/>GET 1<br/>FREE </b></h1>   <h1 className="pl-title2">Black Tea</h1>
      <div className="pl-list">
        {black.map((item) => (
          <Product key={item.id} img={item.img} link={item.link} tests={item.tests}/>
        ))}
      </div>
      </div> */}
    </div>
  );
};

 export default ProductList;
